import {
  CHANGE_ADDRESS_FILTER_GROUP,
  CHANGE_CUSTOM_FIELD_FILTERS,
  CHANGE_INDUSTRIAL_FILTER_GROUP,
  CHANGE_LEASE_FILTER_GROUP,
  CHANGE_LEASE_PAGE,
  CHANGE_LEASE_SORT,
  CHANGE_PROPERTY_FILTER_GROUP,
  CLEAR_FILTERS,
  CHANGE_SALE_FILTER_GROUP,
  CHANGE_SALE_PAGE,
  CHANGE_SALE_SORT,
  CHANGE_SEARCH_TEXT,
  SET_FULL_QUERY,
  SELECT_ASSET_CLASS,
  SELECT_AVAILABILITY,
  SELECT_BUILDING_CLASS,
  SELECT_INVESTMENT_TYPE,
  SET_AVAILABILITIES,
  SET_ASSET_CLASSES,
  SET_BUILDING_CLASSES,
  SET_INVESTMENT_TYPES
} from '../actions/query';

export default function (state = {}, action) {
  switch (action.type) {
  case CLEAR_FILTERS: {
    const { addressFilter, industrialFilter, leaseFilter, saleFilter, propertyFilter } = { ...action.initialState };
    return {
      ...state,
      addressFilter: { ...addressFilter },
      customFieldFilters: {},
      industrialFilter: { ...industrialFilter },
      leaseFilter: { ...leaseFilter },
      saleFilter: { ...saleFilter },
      propertyFilter: { ...propertyFilter },
      availabilities: [],
      assetClasses: [],
      buildingClasses: [],
      investmentTypes: [],
      searchText: "",
    };
  }
  case CHANGE_ADDRESS_FILTER_GROUP: {
    const addressFilter = { ...state.addressFilter, ...action.addressFilter };
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      addressFilter: addressFilter
    };
  }

  case CHANGE_CUSTOM_FIELD_FILTERS:
    return {
      ...state,
      customFieldFilters: {
        ...state.customFieldFilters,
        ...action.changes
      }
    };

  case CHANGE_INDUSTRIAL_FILTER_GROUP: {
    const industrialFilter = { ...state.industrialFilter, ...action.industrialFilter };
    return {
      ...state,
      industrialFilter: industrialFilter,
      propertyPage: 1
    };
  }
  case CHANGE_LEASE_FILTER_GROUP: {
    const leaseFilter = { ...state.leaseFilter, ...action.leaseFilter };
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      leaseFilter: leaseFilter
    };
  }
  case CHANGE_PROPERTY_FILTER_GROUP: {
    const propertyFilter = { ...state.propertyFilter, ...action.propertyFilter };
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      propertyFilter: propertyFilter
    };
  }
  case CHANGE_SALE_FILTER_GROUP: {
    const saleFilter = { ...state.saleFilter, ...action.saleFilter };
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      saleFilter: saleFilter
    };
  }
  case CHANGE_LEASE_PAGE:
    return {
      ...state,
      leasePage: action.page
    };
  case CHANGE_LEASE_SORT:
    return {
      ...state,
      leaseSort: action.sort
    };
  case CHANGE_SALE_PAGE:
    return {
      ...state,
      salePage: action.page
    };
  case CHANGE_SALE_SORT:
    return {
      ...state,
      saleSort: action.sort
    };
  case CHANGE_SEARCH_TEXT:
    return {
      ...state,
      leasePage: 1,
      leaseSort: 'name asc',
      salePage: 1,
      saleSort: 'name asc',
      searchText: action.value
    };
  case SET_FULL_QUERY:
    return {
      ...state,
      ...action.query,
      propertyPage: 1,
    };
  case SELECT_AVAILABILITY: {
    let availabilities = state.availabilities;
    availabilities = _.reject(availabilities, availability => parseInt(availability) === parseInt(action.id));
    if (action.value) {
      availabilities.push(action.id);
    }
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      availabilities: availabilities
    };
  }
  case SELECT_ASSET_CLASS: {
    let assetClasses = state.assetClasses;
    assetClasses = _.reject(assetClasses, assetClass => parseInt(assetClass) === parseInt(action.role));
    if (action.value) {
      assetClasses.push(action.role);
    }
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      assetClasses: assetClasses
    };
  }
  case SELECT_BUILDING_CLASS: {
    let buildingClasses = state.buildingClasses;
    buildingClasses = _.reject(buildingClasses, buildingClass => buildingClass === action.role);
    if (action.value) {
      buildingClasses.push(action.role);
    }
    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      buildingClasses: buildingClasses
    };
  }
  case SELECT_INVESTMENT_TYPE: {
    let { investmentTypes } = state;
    investmentTypes = _.reject({ ...investmentTypes }, type => type === action.key);
    if (action.value) investmentTypes.push(action.key);

    return {
      ...state,
      leasePage: 1,
      salePage: 1,
      investmentTypes
    };
  }
  case SET_AVAILABILITIES:
    return {
      ...state,
      availabilities: action.availabilities
    };
  case SET_ASSET_CLASSES:
    return {
      ...state,
      assetClasses: action.assetClasses
    };
  case SET_BUILDING_CLASSES:
    return {
      ...state,
      buildingClasses: action.buildingClasses
    };
  case SET_INVESTMENT_TYPES:
    return {
      ...state,
      investmentTypes: action.investmentTypes
    };
  default:
    return state;
  }
}
